const COUNTRY_CODE_EN = Object.freeze({
    "AND": "Andorra",
    "ARE": "United Arab Emirates",
    "AFG": "Afghanistan",
    "ATG": "Antigua and Barbuda",
    "AIA": "Anguilla",
    "ALB": "Albania",
    "ARM": "Armenia",
    "AGO": "Angola",
    "ATA": "Antarctica",
    "ARG": "Argentina",
    "ASM": "American Samoa",
    "AUT": "Austria",
    "AUS": "Australia",
    "ABW": "Aruba",
    "ALA": "Aland",
    "AZE": "Azerbaijan",
    "BIH": "Bosnia and Herzegovina",
    "BRB": "Barbados",
    "BGD": "Bangladesh",
    "BEL": "Belgium",
    "BFA": "Burkina Faso",
    "BGR": "Bulgaria",
    "BHR": "Bahrain",
    "BDI": "Burundi",
    "BEN": "Benin",
    "BLM": "Saint Barthélemy",
    "BMU": "Bermuda",
    "BRN": "Brunei",
    "BOL": "Bolivia",
    "BES": "Bonaire",
    "BRA": "Brazil",
    "BHS": "Bahamas",
    "BTN": "Bhutan",
    "BVT": "Bouvet Island",
    "BWA": "Botswana",
    "BLR": "Belarus",
    "BLZ": "Belize",
    "CAN": "Canada",
    "CCK": "Cocos [Keeling] Islands",
    "COD": "Democratic Republic of the Congo",
    "CAF": "Central African Republic",
    "COG": "Republic of the Congo",
    "CHE": "Switzerland",
    "CIV": "Ivory Coast",
    "COK": "Cook Islands",
    "CHL": "Chile",
    "CMR": "Cameroon",
    "CHN": "China",
    "COL": "Colombia",
    "CRI": "Costa Rica",
    "CUB": "Cuba",
    "CPV": "Cape Verde",
    "CUW": "Curacao",
    "CXR": "Christmas Island",
    "CYP": "Cyprus",
    "CZE": "Czechia",
    "DEU": "Germany",
    "DJI": "Djibouti",
    "DNK": "Denmark",
    "DMA": "Dominica",
    "DOM": "Dominican Republic",
    "DZA": "Algeria",
    "ECU": "Ecuador",
    "EST": "Estonia",
    "EGY": "Egypt",
    "ESH": "Western Sahara",
    "ERI": "Eritrea",
    "ESP": "Spain",
    "ETH": "Ethiopia",
    "FIN": "Finland",
    "FJI": "Fiji",
    "FLK": "Falkland Islands",
    "FSM": "Micronesia",
    "FRO": "Faroe Islands",
    "FRA": "France",
    "GAB": "Gabon",
    "GBR": "United Kingdom",
    "GRD": "Grenada",
    "GEO": "Georgia",
    "GUF": "French Guiana",
    "GGY": "Guernsey",
    "GHA": "Ghana",
    "GIB": "Gibraltar",
    "GRL": "Greenland",
    "GMB": "Gambia",
    "GIN": "Guinea",
    "GLP": "Guadeloupe",
    "GNQ": "Equatorial Guinea",
    "GRC": "Greece",
    "SGS": "South Georgia and the South Sandwich Islands",
    "GTM": "Guatemala",
    "GUM": "Guam",
    "GNB": "Guinea-Bissau",
    "GUY": "Guyana",
    "HKG": "Hong Kong, China",
    "HMD": "Heard Island and McDonald Islands",
    "HND": "Honduras",
    "HRV": "Croatia",
    "HTI": "Haiti",
    "HUN": "Hungary",
    "IDN": "Indonesia",
    "IRL": "Ireland",
    "ISR": "Israel",
    "IMN": "Isle of Man",
    "IND": "India",
    "IOT": "British Indian Ocean Territory",
    "IRQ": "Iraq",
    "IRN": "Iran",
    "ISL": "Iceland",
    "ITA": "Italy",
    "JEY": "Jersey",
    "JAM": "Jamaica",
    "JOR": "Jordan",
    "JPN": "Japan",
    "KEN": "Kenya",
    "KGZ": "Kyrgyzstan",
    "KHM": "Cambodia",
    "KIR": "Kiribati",
    "COM": "Comoros",
    "KNA": "Saint Kitts and Nevis",
    "PRK": "North Korea",
    "KOR": "South Korea",
    "KWT": "Kuwait",
    "CYM": "Cayman Islands",
    "KAZ": "Kazakhstan",
    "LAO": "Laos",
    "LBN": "Lebanon",
    "LCA": "Saint Lucia",
    "LIE": "Liechtenstein",
    "LKA": "Sri Lanka",
    "LBR": "Liberia",
    "LSO": "Lesotho",
    "LTU": "Lithuania",
    "LUX": "Luxembourg",
    "LVA": "Latvia",
    "LBY": "Libya",
    "MAR": "Morocco",
    "MCO": "Monaco",
    "MDA": "Moldova",
    "MNE": "Montenegro",
    "MAF": "Saint Martin",
    "MDG": "Madagascar",
    "MHL": "Marshall Islands",
    "MKD": "Macedonia",
    "MLI": "Mali",
    "MMR": "Myanmar [Burma]",
    "MNG": "Mongolia",
    "MAC": "Macao, China",
    "MNP": "Northern Mariana Islands",
    "MTQ": "Martinique",
    "MRT": "Mauritania",
    "MSR": "Montserrat",
    "MLT": "Malta",
    "MUS": "Mauritius",
    "MDV": "Maldives",
    "MWI": "Malawi",
    "MEX": "Mexico",
    "MYS": "Malaysia",
    "MOZ": "Mozambique",
    "NAM": "Namibia",
    "NCL": "New Caledonia",
    "NER": "Niger",
    "NFK": "Norfolk Island",
    "NGA": "Nigeria",
    "NIC": "Nicaragua",
    "NLD": "Netherlands",
    "NOR": "Norway",
    "NPL": "Nepal",
    "NRU": "Nauru",
    "NIU": "Niue",
    "NZL": "New Zealand",
    "OMN": "Oman",
    "PAN": "Panama",
    "PER": "Peru",
    "PYF": "French Polynesia",
    "PNG": "Papua New Guinea",
    "PHL": "Philippines",
    "PAK": "Pakistan",
    "POL": "Poland",
    "SPM": "Saint Pierre and Miquelon",
    "PCN": "Pitcairn Islands",
    "PRI": "Puerto Rico",
    "PSE": "Palestine",
    "PRT": "Portugal",
    "PLW": "Palau",
    "PRY": "Paraguay",
    "QAT": "Qatar",
    "REU": "Réunion",
    "ROU": "Romania",
    "SRB": "Serbia",
    "RUS": "Russia",
    "RWA": "Rwanda",
    "SAU": "Saudi Arabia",
    "SLB": "Solomon Islands",
    "SYC": "Seychelles",
    "SDN": "Sudan",
    "SWE": "Sweden",
    "SGP": "Singapore",
    "SHN": "Saint Helena",
    "SVN": "Slovenia",
    "SJM": "Svalbard and Jan Mayen",
    "SVK": "Slovakia",
    "SLE": "Sierra Leone",
    "SMR": "San Marino",
    "SEN": "Senegal",
    "SOM": "Somalia",
    "SUR": "Suriname",
    "SSD": "South Sudan",
    "STP": "São Tomé and Príncipe",
    "SLV": "El Salvador",
    "SXM": "Sint Maarten",
    "SYR": "Syria",
    "SWZ": "Swaziland",
    "TCA": "Turks and Caicos Islands",
    "TCD": "Chad",
    "ATF": "French Southern Territories",
    "TGO": "Togo",
    "THA": "Thailand",
    "TJK": "Tajikistan",
    "TKL": "Tokelau",
    "TLS": "East Timor",
    "TKM": "Turkmenistan",
    "TUN": "Tunisia",
    "TON": "Tonga",
    "TUR": "Turkey",
    "TTO": "Trinidad and Tobago",
    "TUV": "Tuvalu",
    "TWN": "Taiwan, China",
    "TZA": "Tanzania",
    "UKR": "Ukraine",
    "UGA": "Uganda",
    "UMI": "U.S. Minor Outlying Islands",
    "USA": "United States",
    "URY": "Uruguay",
    "UZB": "Uzbekistan",
    "VAT": "Vatican City",
    "VCT": "Saint Vincent and the Grenadines",
    "VEN": "Venezuela",
    "VGB": "British Virgin Islands",
    "VIR": "U.S. Virgin Islands",
    "VNM": "Vietnam",
    "VUT": "Vanuatu",
    "WLF": "Wallis and Futuna",
    "WSM": "Samoa",
    "XKX": "Kosovo",
    "YEM": "Yemen",
    "MYT": "Mayotte",
    "ZAF": "South Africa",
    "ZMB": "Zambia",
    "ZWE": "Zimbabwe",
});

const COUNTRY_CODE_ZH_TW = Object.freeze({
    "AND": "安道爾",
    "ARE": "阿拉伯聯合酋長國",
    "AFG": "阿富汗",
    "ATG": "安提瓜和巴布達",
    "AIA": "安圭拉",
    "ALB": "阿爾巴尼亞",
    "ARM": "亞美尼亞",
    "AGO": "安哥拉",
    "ATA": "南極洲",
    "ARG": "阿根廷",
    "ASM": "美屬薩摩亞",
    "AUT": "奧地利",
    "AUS": "澳大利亞",
    "ABW": "阿魯巴",
    "ALA": "奧蘭羣島",
    "AZE": "阿塞拜疆",
    "BIH": "波斯尼亞和黑山共和國",
    "BRB": "巴巴多斯",
    "BGD": "孟加拉",
    "BEL": "比利時",
    "BFA": "布基納法索",
    "BGR": "保加利亞",
    "BHR": "巴林",
    "BDI": "布隆迪",
    "BEN": "貝寧",
    "BLM": "聖巴泰勒米",
    "BMU": "百慕大",
    "BRN": "文萊",
    "BOL": "玻利維亞",
    "BES": "博奈爾島、聖尤斯達蒂斯和薩巴",
    "BRA": "巴西",
    "BHS": "巴哈馬",
    "BTN": "不丹",
    "BVT": "布維特島",
    "BWA": "博茨瓦納",
    "BLR": "白俄羅斯",
    "BLZ": "伯利茲",
    "CAN": "加拿大",
    "CCK": "科科斯羣島",
    "COD": "扎伊爾",
    "CAF": "中非共和國",
    "COG": "剛果",
    "CHE": "瑞士",
    "CIV": "象牙海岸",
    "COK": "庫克羣島",
    "CHL": "智利",
    "CMR": "喀麥隆",
    "CHN": "中國",
    "COL": "哥倫比亞",
    "CRI": "哥斯達黎加",
    "CUB": "古巴",
    "CPV": "佛得角",
    "CUW": "庫拉索",
    "CXR": "聖誕島",
    "CYP": "塞浦路斯",
    "CZE": "捷克共和國",
    "DEU": "德國",
    "DJI": "吉布提",
    "DNK": "丹麥",
    "DMA": "多米尼加",
    "DOM": "多米尼加共和國",
    "DZA": "阿爾及利亞",
    "ECU": "厄瓜多爾",
    "EST": "愛沙尼亞",
    "EGY": "埃及",
    "ESH": "西撒哈拉",
    "ERI": "厄立特里亞",
    "ESP": "西班牙",
    "ETH": "埃塞俄比亞",
    "FIN": "芬蘭",
    "FJI": "斐濟",
    "FLK": "福克蘭羣島",
    "FSM": "密克羅尼西亞",
    "FRO": "法羅羣島",
    "FRA": "法國",
    "GAB": "加蓬",
    "GBR": "英國",
    "GRD": "格林納達",
    "GEO": "格魯吉亞",
    "GUF": "法屬圭亞那",
    "GGY": "格恩西島",
    "GHA": "加納",
    "GIB": "直布羅陀",
    "GRL": "格陵蘭",
    "GMB": "岡比亞",
    "GIN": "幾內亞",
    "GLP": "瓜德羅普島",
    "GNQ": "赤道幾內亞",
    "GRC": "希臘",
    "SGS": "南喬治亞島和南桑威齊羣島",
    "GTM": "危地馬拉",
    "GUM": "關島",
    "GNB": "幾內亞比紹",
    "GUY": "圭亞那",
    "HKG": "中國香港",
    "HMD": "赫德與麥克唐納羣島",
    "HND": "洪都拉斯",
    "HRV": "克羅地亞",
    "HTI": "海地",
    "HUN": "匈牙利",
    "IDN": "印度尼西亞",
    "IRL": "愛爾蘭",
    "ISR": "以色列",
    "IMN": "曼島",
    "IND": "印度",
    "IOT": "英屬印度洋領地",
    "IRQ": "伊拉克",
    "IRN": "伊朗伊斯蘭共和國",
    "ISL": "冰島",
    "ITA": "意大利",
    "JEY": "澤西島",
    "JAM": "牙買加",
    "JOR": "約旦",
    "JPN": "日本",
    "KEN": "肯尼亞",
    "KGZ": "吉爾吉克斯坦",
    "KHM": "柬埔寨",
    "KIR": "基里巴斯",
    "COM": "科摩羅",
    "KNA": "聖基茨和尼維斯",
    "PRK": "朝鮮民主共和國",
    "KOR": "大韓民國",
    "KWT": "科威特",
    "CYM": "開曼羣島",
    "KAZ": "哈薩克斯坦",
    "LAO": "老撾人民民主共和國",
    "LBN": "黎巴嫩",
    "LCA": "聖盧西亞",
    "LIE": "列支敦士登",
    "LKA": "斯里蘭卡",
    "LBR": "利比里亞",
    "LSO": "萊索托",
    "LTU": "立陶宛",
    "LUX": "盧森堡",
    "LVA": "拉脫維亞",
    "LBY": "阿拉伯利比亞民衆國",
    "MAR": "摩洛哥",
    "MCO": "摩納哥",
    "MDA": "摩爾多瓦共和國",
    "MNE": "黑山共和國",
    "MAF": "聖馬丁",
    "MDG": "馬達加斯加",
    "MHL": "馬紹爾羣島",
    "MKD": "前南斯拉夫馬其頓共和國",
    "MLI": "馬裏",
    "MMR": "緬甸",
    "MNG": "蒙古",
    "MAC": "中國澳門",
    "MNP": "北馬裏亞納羣島",
    "MTQ": "馬提尼克羣島",
    "MRT": "毛里塔尼亞",
    "MSR": "蒙塞拉特羣島",
    "MLT": "馬耳他",
    "MUS": "毛里求斯",
    "MDV": "馬爾代夫",
    "MWI": "馬拉維",
    "MEX": "墨西哥",
    "MYS": "馬來西亞",
    "MOZ": "莫桑比克",
    "NAM": "納米比亞",
    "NCL": "新喀里多尼亞",
    "NER": "尼日爾",
    "NFK": "諾福克島",
    "NGA": "尼日利亞",
    "NIC": "尼加拉瓜",
    "NLD": "荷蘭",
    "NOR": "挪威",
    "NPL": "尼泊爾",
    "NRU": "瑙魯",
    "NIU": "紐埃",
    "NZL": "新西蘭",
    "OMN": "阿曼",
    "PAN": "巴拿馬",
    "PER": "祕魯",
    "PYF": "法屬波利尼西亞",
    "PNG": "巴布亞新幾內亞",
    "PHL": "菲律賓",
    "PAK": "巴基斯坦",
    "POL": "波蘭",
    "SPM": "聖皮埃爾和密克隆",
    "PCN": "皮特凱恩羣島",
    "PRI": "波多黎各",
    "PSE": "巴勒斯坦領土",
    "PRT": "葡萄牙",
    "PLW": "帕勞",
    "PRY": "巴拉圭",
    "QAT": "卡塔爾",
    "REU": "留尼汪",
    "ROU": "羅馬尼亞",
    "SRB": "塞爾維亞",
    "RUS": "俄羅斯",
    "RWA": "盧旺達",
    "SAU": "沙特阿拉伯",
    "SLB": "所羅門羣島",
    "SYC": "塞舌爾羣島",
    "SDN": "蘇丹",
    "SWE": "瑞典",
    "SGP": "新加坡",
    "SHN": "聖赫勒拿",
    "SVN": "斯洛文尼亞",
    "SJM": "斯瓦爾巴特和揚馬延",
    "SVK": "斯洛伐克共和國",
    "SLE": "塞拉利昂",
    "SMR": "聖馬力諾",
    "SEN": "塞內加爾",
    "SOM": "索馬里",
    "SUR": "蘇里南",
    "SSD": "南蘇丹",
    "STP": "聖多美和普林西比",
    "SLV": "薩爾瓦多",
    "SXM": "聖馬丁島",
    "SYR": "敘利亞",
    "SWZ": "斯威士蘭",
    "TCA": "特克斯和凱科斯羣島",
    "TCD": "乍得",
    "ATF": "法屬南部領土",
    "TGO": "多哥",
    "THA": "泰國",
    "TJK": "塔吉克斯坦",
    "TKL": "托克勞",
    "TLS": "東帝汶",
    "TKM": "土庫曼斯坦",
    "TUN": "突尼斯",
    "TON": "湯加",
    "TUR": "土耳其",
    "TTO": "特立尼達和多巴哥",
    "TUV": "圖瓦盧",
    "TWN": "中國臺灣",
    "TZA": "坦桑尼亞",
    "UKR": "烏克蘭",
    "UGA": "烏干達",
    "UMI": "美國邊遠小島",
    "USA": "美國",
    "URY": "烏拉圭",
    "UZB": "烏茲別克斯坦",
    "VAT": "聖座（梵蒂岡）",
    "VCT": "聖文森特和格林納丁斯",
    "VEN": "委內瑞拉",
    "VGB": "英屬維京羣島",
    "VIR": "美屬維京羣島",
    "VNM": "越南",
    "VUT": "瓦努阿圖",
    "WLF": "瓦利斯和富圖納",
    "WSM": "薩摩亞",
    "XKX": "科索沃",
    "YEM": "也門",
    "MYT": "馬約特",
    "ZAF": "南非",
    "ZMB": "贊比亞",
    "ZWE": "津巴布韋",
});


export {
    COUNTRY_CODE_EN,
    COUNTRY_CODE_ZH_TW
}